export default __webpack_public_path__ + "74f967f84ebaf8cf448bb7f0a36864c4.png";